import styled from '@emotion/styled'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export const InputText = styled.input`
  flex: 1;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 14px;
  padding-right: 14px;
  width: 100%;
  border-color: ${chakraTokenToVar('border')};
  border-radius: 4px;
  border-style: solid;
  outline: none;
  border-width: 1px;
  min-height: 38px;
  text-align: left;
  font: inherit;
  &:focus-visible {
    outline: solid ${chakraTokenToVar('primary.focusRing')};
  }
  &:disabled {
    background-color: hsl(0, 0%, 95%);
    color: hsl(0, 0%, 60%);
  }
`

export const InputSelect = styled.div`
  flex: 1;
  width: 100%;
`
